import { createSlice } from "@reduxjs/toolkit";


export const stockArticlesSlice = createSlice({
    name: 'stockArticles',
    initialState:{},
    reducers: { // change shopping step to manage app navigation
       
        addStockArticles: (currentState, action) => {

            let newList = currentState.filter((article)=>article.article_id!==action.payload.article_id);
            newList.push(action.payload);
            return newList;

        },
        setStockArticles: (currentState, action) => {
            
            return action.payload;

        }
    }
});

